import { render, staticRenderFns } from "./crossover.vue?vue&type=template&id=851f908c&scoped=true&"
import script from "./crossover.vue?vue&type=script&lang=js&"
export * from "./crossover.vue?vue&type=script&lang=js&"
import style0 from "./crossover.vue?vue&type=style&index=0&id=851f908c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "851f908c",
  null
  
)

export default component.exports